module.exports = __webpack_public_path__ + "images/_/assets/images/logo_salvador.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_salvador.png
// module id = ./src/assets/images/logo_salvador.png
// module chunks = 1